import * as api from '../../../clients/benutzerverwaltung';

import {Action} from '@ngrx/store';

export const POST_BENUTZER_LOESCHEN_ADMIN = '[BenutzerverwaltungModul] PostBenutzerLoeschenAdmin laden';
export const POST_BENUTZER_LOESCHEN_ADMIN_AUSFUEHREN = '[BenutzerverwaltungModul] PostBenutzerLoeschenAdmin ausführen';
export const POST_BENUTZER_LOESCHEN_ADMIN_ERFOLGREICH = '[BenutzerverwaltungModul] PostBenutzerLoeschenAdmin laden erfolgreich';
export const POST_BENUTZER_LOESCHEN_ADMIN_FEHLER = '[BenutzerverwaltungModul] PostBenutzerLoeschenAdmin Ladefehler';
export const POST_BENUTZER_LOESCHEN_ADMIN_NICHT_AUSGEFUEHRT = '[BenutzerverwaltungModul] PostBenutzerLoeschenAdmin nicht ausgeführt (evtl. Offline)';


export class PostBenutzerLoeschenAdminAction implements Action {
    readonly type = POST_BENUTZER_LOESCHEN_ADMIN;
        constructor(public benutzerRequest: api.BenutzerRequest, public optPayload: any = null) {}
    }
export class PostBenutzerLoeschenAdminAusfuehrenAction implements Action {
    readonly type = POST_BENUTZER_LOESCHEN_ADMIN_AUSFUEHREN;
        constructor(public benutzerRequest: api.BenutzerRequest, public optPayload: any = null) {}
    }
export class PostBenutzerLoeschenAdminErfolgreichAction implements Action {
    readonly type = POST_BENUTZER_LOESCHEN_ADMIN_ERFOLGREICH;
        constructor(public payload: api.BenutzerIdentifier, public benutzerRequest: api.BenutzerRequest, public optPayload: any = null) {}
    }
export class PostBenutzerLoeschenAdminFehlerAction implements Action {
    readonly type = POST_BENUTZER_LOESCHEN_ADMIN_FEHLER;
        constructor(public payload: any, public benutzerRequest: api.BenutzerRequest, public optPayload: any = null) {}
    }
export class PostBenutzerLoeschenAdminNichtAusgefuehrtAction implements Action {
    readonly type = POST_BENUTZER_LOESCHEN_ADMIN_NICHT_AUSGEFUEHRT;
        constructor(public optPayload: any = null) {}
    }
    

export type BenutzerverwaltungCommandBenutzerLoeschenAdminActions =
    PostBenutzerLoeschenAdminAction
    | PostBenutzerLoeschenAdminAusfuehrenAction
    | PostBenutzerLoeschenAdminErfolgreichAction
    | PostBenutzerLoeschenAdminFehlerAction
    | PostBenutzerLoeschenAdminNichtAusgefuehrtAction
    ;
